//-----------------------------------------------------------------------------
//----- Copyright deersoft 2015 - 2019 www.deersoft.de
//-----------------------------------------------------------------------------
import LocalizedStrings from "localized-strings";
import LocalizeOption from "./LocalizationOption";

import en from "./raw/en/ErrorComponent.json";
import de from "./raw/de/ErrorComponent.json";
import es from "./raw/es/ErrorComponent.json";
import fr from "./raw/fr/ErrorComponent.json";
import it from "./raw/it/ErrorComponent.json";
import ru from "./raw/ru/ErrorComponent.json";
import cz from "./raw/cs/ErrorComponent.json";
import tr from "./raw/tr/ErrorComponent.json";
import zh from "./raw/zh/ErrorComponent.json";
import ja from "./raw/ja/ErrorComponent.json";
import nl from "./raw/nl/ErrorComponent.json";
import pt from "./raw/pt/ErrorComponent.json";

const Strings = new LocalizedStrings(
  {
    en: en,
    de: de,
    es: es,
    fr: fr,
    zh: zh,
    tr: tr,
    ja: ja,
    ru: ru,
    it: it,
    cz: cz,
    nl: nl,
    pt: pt,
  },
  { ...LocalizeOption },
);

export default Strings;
